export default [
    {
        path: '/sales/customer',
        name: 'customer',
        props: true,
        component: () => import('@/views/sales/customer/index.vue'),
        meta: {
            pageTitle: 'Customer',
            breadcrumb: [
                {
                text: 'Customer',
                active: true,
                },
            ],
        },
    },
    {
        path: '/sales/customer/add',
        name: 'create-customer',
        component: () => import('@/views/sales/customer/create.vue'),
        meta: {
            pageTitle: 'Create Customer',
            breadcrumb: [
                {
                text: 'Customer',
                to: { name: 'customer' },
                },
                {
                text: 'Create Customer',
                active: true,
                },
            ],
        },
    },
    {
        path: '/sales/customer/:id',
        name: 'detail-customer',
        props: true,
        component: () => import('@/views/sales/customer/detail.vue'),
        meta: {
            pageTitle: 'Detail Customer',
            breadcrumb: [
                {
                text: 'Customer',
                to: { name: 'customer' },
                },
                {
                text: 'Detail Customer',
                active: true,
                },
            ],
        },
    },
]